import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScSliderContainer = styled.div`
  width: 100%;
  overflow: hidden;
  min-height: 400px;

  @media (${device.mobile}) {
    .pagination {
      padding-bottom: 28px;
    }
  }
`;
